import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { createSelectors } from '@trg/utils';

type LoadingState = {
  loadings: number;
};

type LoadingAction = {
  showLoading(): void;
  closeLoading(): void;
};

type LoadingStore = LoadingState & LoadingAction;

const useLoadingStoreBase = create<LoadingStore>()(
  devtools(
    (set, get) => ({
      loadings: 0,
      showLoading() {
        set(({ loadings }) => ({ loadings: loadings + 1 }));
      },
      closeLoading() {
        set(({ loadings }) => ({
          loadings: loadings < 1 ? 0 : loadings - 1,
        }));
      },
    }),
    {
      name: 'loading',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
);

export const useLoadingStore = createSelectors(useLoadingStoreBase);
